import React, { useEffect, useState } from 'react';
import { Container } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
//Import Breadcrumb
import _ from 'lodash'
import Breadcrumbs from '../../components/Common/Breadcrumb';
import { userSubscriberList} from '../../services/api/api-service';
//Import Image
import List from './ListComponent/list';
const SubscriberUser = (props) => {
    const [businessList, setbusinessList] = useState([]);
    const [stateValue, setStateValue] = useState(null);
    useEffect(() => {
        userSubscriberList('A').then(data => {
            if (!_.isEmpty(data)) {
                setbusinessList(data)
            }
        })
    }, [stateValue])
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    {/* Render Breadcrumbs */}
                    <Breadcrumbs title="Listing" breadcrumbItem="Subscriber List" />
                    <List title={'Subscriber User list'} listData={businessList} userlists={setbusinessList} userFilterType="MTSUBSCRIBE"/>             
                </Container>
            </div>
        </React.Fragment>
    );
}
export default SubscriberUser;